import { useState } from "react";
import { Modal, Button } from "react-bootstrap";

// Carga manual del PPM o IUT real del contador para un mes cerrado (bloque F29 del tab
// Impuestos). El modal solo captura el valor; el padre hace el upsert a impuestos_f29_override
// + refetch. Al cargar un valor, esa línea deja de ser estimación (desaparece el tag).

const LABELS = { ppm: "PPM", iut: "IUT" };

const OverrideF29Modal = ({ show, onHide, entry, campo, periodo, onSave }) => {
  const [valor, setValor] = useState(entry ? String(Math.abs(Math.round(Number(entry.importeEnMoneda || 0)))) : "");
  const [guardando, setGuardando] = useState(false);

  if (!entry) return null;

  const label = LABELS[campo] || campo?.toUpperCase();

  const handleGuardar = async () => {
    const n = Math.round(Number(valor));
    if (!Number.isFinite(n) || n < 0) return;
    setGuardando(true);
    try {
      await onSave(n);
    } finally {
      setGuardando(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: "1.1rem" }}>
          Cargar {label} del contador — {periodo}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={{ fontSize: "0.9rem", lineHeight: 1.7, marginBottom: 14 }}>
          Ingresá el valor real de <strong>{label}</strong> declarado por el contador para el período{" "}
          <strong>{periodo}</strong>. Reemplaza la estimación y esa línea deja de mostrar el tag «Estimado».
        </div>
        <input
          type="number"
          min="0"
          value={valor}
          onChange={(e) => setValor(e.target.value)}
          autoFocus
          style={{
            width: "100%",
            padding: "8px 10px",
            fontSize: "1rem",
            border: "1px solid #ccc",
            borderRadius: 4,
          }}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} disabled={guardando}>
          Cancelar
        </Button>
        <Button variant="primary" onClick={handleGuardar} disabled={guardando || valor === ""}>
          {guardando ? "Guardando…" : "Guardar"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default OverrideF29Modal;
